import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CenteredTextConverter extends CmsConverterService<CenteredTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_centered_text ?? defaultTextInput,
    }
  }
}

export const CENTERED_TEXT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CenteredTextData>>('CenteredTextConverterToken')

export interface CenteredTextData extends ConvertedComponentData {
  text: TextInput;
}
